import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

function PopularValues({ name, answerQuestion, options }) {
  const { t } = useTranslation('qualification');

  return (
    <FlexBox
      flexWrap="wrap"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap={1.5}
      px={2}
      id={name}
    >
      <Typography variant="caption" fontWeight={500}>
        {t('popularValues')}
      </Typography>
      {options.map((option, index) => (
        <Box
          key={`${option.value}::${index}`}
          onClick={() => answerQuestion(option.value)}
        >
          <StyledTypography variant="caption">{option.label}</StyledTypography>
        </Box>
      ))}
    </FlexBox>
  );
}

export default PopularValues;

const FlexBox = styled(Box)`
  display: flex;
  gap: ${(props) => props.gap || 0}rem;
`;

const StyledTypography = styled(Typography)`
  border-bottom: 1px dotted #000;
  cursor: pointer;
`;
